import { getProjectCoreStakeholdersReducerActionType } from '@gp/pages/Pipeline/ProjectDetails/Stakeholder/components/StakeholderEdit/utils';

const ADD_TYPE_PROJECT_CORE_STAKEHOLDERS =
  getProjectCoreStakeholdersReducerActionType('ADD_TYPE');

const DELETE_TYPE_PROJECT_CORE_STAKEHOLDERS =
  getProjectCoreStakeholdersReducerActionType('DELETE_TYPE');

const SELECT_TYPE_PROJECT_CORE_STAKEHOLDERS =
  getProjectCoreStakeholdersReducerActionType('SELECT_TYPE');

const ADD_EMP_PROJECT_CORE_STAKEHOLDERS =
  getProjectCoreStakeholdersReducerActionType('ADD_EMP');

const DELETE_EMP_PROJECT_CORE_STAKEHOLDERS =
  getProjectCoreStakeholdersReducerActionType('DELETE_EMP');

const UPDATE_EMP_PROJECT_CORE_STAKEHOLDERS =
  getProjectCoreStakeholdersReducerActionType('UPDATE_EMP');

export {
  ADD_TYPE_PROJECT_CORE_STAKEHOLDERS,
  DELETE_TYPE_PROJECT_CORE_STAKEHOLDERS,
  SELECT_TYPE_PROJECT_CORE_STAKEHOLDERS,
  ADD_EMP_PROJECT_CORE_STAKEHOLDERS,
  DELETE_EMP_PROJECT_CORE_STAKEHOLDERS,
  UPDATE_EMP_PROJECT_CORE_STAKEHOLDERS,
};
